




























































import Vue from "vue";
import RestClient, { RestError } from "../RestClient";

import Login from "../components/general/Login.vue";
import AppFrame from "../components/general/AppFrame.vue";
import Navigation from "../components/general/Navigation.vue";
import Loading from "../components/general/Loading.vue";

import Events from "../components/events/Events.vue";
import Birthdays from "../components/birthdays/Birthdays.vue";
import Holidays from "../components/holidays/Holidays.vue";
import Workshops from "../components/workshops/Workshops.vue";
import Groups from "../components/groups/Groups.vue";
import Members from "../components/members/Members.vue";
import Rental from "../components/rental/Rental.vue";
import Mailings from "../components/mailings/Mailings.vue";
import Clients from "../components/clients/Clients.vue";
import Payments from "../components/payments/Payments.vue";
import Statistics from "../components/statistics/Statistics.vue";
import Settings from "../components/settings/Settings.vue";

import SettingsJson from "../shared/SettingsJson";
import SettingsNotificationsJson from "../shared/SettingsNotificationsJson";
import ModulesJson from "../shared/ModulesJson";
import UserJson from "../shared/UserJson";

import { checkPermission } from "../shared/UserPermission";

export default Vue.extend({
  name: "verwaltung",
  components: {
    Login,
    AppFrame,
    Navigation,
    Loading,
    Events,
    Birthdays,
    Holidays,
    Workshops,
    Groups,
    Members,
    Mailings,
    Clients,
    Rental,
    Payments,
    Statistics,
    Settings,
  },
  data() {
    return {
      loggedin: false,
      loginUser: null as UserJson | null,
      loginId: null as number | null,
      loginName: "",
      loginPassword: "",
      loginPermission: 1 as number,
      restClient: null as RestClient | null,
      settings: null as SettingsJson | null,
      settingsNotifications: null as SettingsNotificationsJson | null,
      allCustomerModules: null as ModulesJson[] | null,
      //allUserModules: null as ModulesJson[] | null,
      //allActiveModules: null as ModulesJson[] | null,
      //userActiveModules: null as ModulesJson[] | null,
      currentPageComponent: null as string | null,
      currentPageTitle: "",
      childHasChanges: false as boolean,
      appFrameButtons: null as object | null,
      appFrameClickedButton: null as object | null,
      showSidebar: false as boolean,
      reload: null as Date | null,
      showLoadingIndicator: false as boolean,
    };
  },
  created() {},
  methods: {
    login: function (
      loginId: number,
      loginName: string,
      loginPassword: string,
      loginPermission: number,
      user: UserJson
    ) {
      this.loggedin = true;
      this.loginUser = user;
      this.loginId = loginId;
      this.loginName = loginName;
      this.loginPassword = loginPassword;
      this.loginPermission = loginPermission;
      this.initAfterLogin();
    },

    async initAfterLogin() {
      this.initRestClient();
      await this.loadSettings();
      await this.loadSettingsNotifications();
      await this.getModules();
    },

    initRestClient() {
      this.restClient = new RestClient(this.loginName, this.loginPassword);
    },

    async loadSettings() {
      this.settings = null;
      this.showLoadingIndicator = true;

      if (this.restClient != null) {
        try {
          this.settings = await this.restClient.getSettings();
          this.showLoadingIndicator = false;
        } catch (e) {
          alert(e.message);
          this.showLoadingIndicator = false;
        }
      }

      this.showLoadingIndicator = false;
    },

    async loadSettingsNotifications() {
      this.settingsNotifications = null;
      this.showLoadingIndicator = true;

      if (this.restClient != null) {
        try {
          this.settingsNotifications = await this.restClient.getSettingsNotifications();
          this.showLoadingIndicator = false;
        } catch (e) {
          alert(e.message);
          this.showLoadingIndicator = false;
        }
      }

      this.showLoadingIndicator = false;
    },

    async reloadSettings() {
      await this.loadSettings();
    },

    async reloadSettingsNotifications() {
      await this.loadSettingsNotifications();
    },

    async reloadModules() {
      await this.getModules();
    },

    async reloadLoginUser() {
      //TODO
    },

    async getModules() {
      if (this.restClient != null && this.loginUser != null) {
        try {
          this.allCustomerModules = await this.restClient.getAllModules();

          await this.setStartpage();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async setStartpage() {
      if (this.userActiveModules != null && this.userActiveModules.length > 0) {
        let firstActive = this.userActiveModules[0];
        if (firstActive) {
          this.currentPageComponent = firstActive.linkedComponent;
          this.currentPageTitle = firstActive.title;
        }
      }
    },

    changeLoginData(loginName: string | null, loginPermission: number | null, loginPassword: string | null) {
      if (loginName != null) {
        this.loginName = loginName;
      }
      if (loginPermission != null) {
        this.loginPermission = loginPermission;
      }
      if (loginPassword != null) {
        this.loginPassword = loginPassword;
      }

      this.initRestClient();
    },

    /*
      changePage: function (page: [string, string]) {
         this.currentPageComponent = page[0]
         this.currentPageTitle = page[1]
      },
      */

    changePage(component: string, title: string): void {
      if (this.childHasChanges) {
        let c = confirm("Es gibt Eingaben, die noch nicht gespeichert wurden. Wollen Sie wirklich fortfahren?");
        if (c == true) {
          this.childHasChanges = false;
          this.currentPageComponent = null;

          this.$nextTick(() => {
            this.currentPageComponent = component;
            this.currentPageTitle = title;
            this.appFrameButtons = null;
            this.showSidebar = false;
          });
        } else {
          //do nothing
        }
      } else {
        this.currentPageComponent = null;

        this.$nextTick(() => {
          this.currentPageComponent = component;
          this.currentPageTitle = title;
          this.appFrameButtons = null;
          this.showSidebar = false;
        });
      }
    },

    setChildHasChanges(changes: boolean): void {
      this.childHasChanges = changes;
    },

    appFrameButtonsToShow(buttons: Object) {
      this.appFrameButtons = buttons;
    },

    appFrameButtonClicked(button: Object) {
      this.appFrameClickedButton = button;
    },

    toggleSidebar() {
      this.showSidebar = !this.showSidebar;
    },
  },
  computed: {
    allUserModules(): ModulesJson[] | null {
      let allUserModules = this.allCustomerModules?.filter((i: ModulesJson) =>
        checkPermission(this.loginUser!, i.permissionRank, i.userPermission)
      );

      return allUserModules ? allUserModules : null;
    },

    allActiveModules(): ModulesJson[] | null {
      let allActiveModules = this.allCustomerModules?.filter((i: ModulesJson) => !i.isDisabled);

      return allActiveModules ? allActiveModules : null;
    },

    userActiveModules(): ModulesJson[] | null {
      let userActiveModules = this.allUserModules?.filter((i: ModulesJson) => !i.isDisabled);

      return userActiveModules ? userActiveModules : null;
    },
  },
});
